// extracted by mini-css-extract-plugin
export var statItem = "_c9-1";
export var statsRow = "_c9-0";